const useRestrictionTrack = (track, isEnabled) => {
  return false
};
export default useRestrictionTrack;
